import React, { memo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import sword from 'images/three_d_studio/variations_tab/sword.webp'

function EmptyState() {
  const t = useTranslation()

  return (
    <div className="variations-tab__empty">
      <p className="variations-tab__empty-label cgt-body-base-semibold">
        {t('viewerSidebar.enhance.variations.emptyState')}
      </p>
      <div className="variations-tab__preview" aria-hidden="true">
        <span className="variations-tab__card variations-tab__card--back" />
        <span className="variations-tab__card variations-tab__card--middle" />
        <span className="variations-tab__card variations-tab__card--front">
          <img
            alt=""
            className="variations-tab__preview-image"
            src={sword}
            height={133}
            width={112}
          />
        </span>
      </div>
    </div>
  )
}

export default memo(EmptyState)
